import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { propsBlocker } from '../../../../system';
export var HeaderNavigationMenuContentRoot = styled.div.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-width: 280px;\n    max-width: 360px;\n    cursor: default;\n    outline: none;\n    user-select: none;\n"])));